export default __webpack_public_path__ + "static/applet-09-set-1-3ae4f2da54b16be0374c5791baf3e388.webp";